import React from 'react';

/**
 * Icon wrapper that checks for branding before returning the SVG component.
 *
 * @returns {JSX.Element}
 */
const withBranding = ({ DefaultIcon, iconName }) => (props: any) => {
    return <DefaultIcon { ...props } />;
};

export default withBranding;